module.exports = __webpack_public_path__ + "img/sp-1.e75e800e.png";